import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_HTML_COMPONENTS_QUERY_KEY } from '@/state/queries/html-components/use-get-html-components';

export interface UpdateHtmlComponentDto {
  name?: string;
  html?: string;
  version?: number;
}

export const useUpdateHtmlComponentMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateHtmlComponentDto }) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/html-components/${id}`;
      return sendJSONRequest({ url, method: METHOD.PATCH, body: data, token: token ?? undefined });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_HTML_COMPONENTS_QUERY_KEY] });
    },
  });
};
